import { HttpErrorService } from '~/services/HttpError.service'
import { serviceErrorHandbook } from '~/models'
import { HttpService } from '~/services/Http.service'

export class DebugService {
  private endpoint = '/internal/debug'
  private httpErrorService: HttpErrorService<keyof typeof serviceErrorHandbook>
  private httpService: HttpService
  private readonly apiBaseUrl: string

  constructor(httpService: HttpService, apiBaseUrl: string) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(serviceErrorHandbook, 'utils')
    this.apiBaseUrl = apiBaseUrl
  }

  async clearCache() {
    const url = [this.endpoint, 'clear/cache'].join('/')

    return await this.httpService
      .get(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          baseUrl: this.getBaseUrl(),
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  async reindexSearch() {
    const url = [this.endpoint, 'reindex/domain'].join('/')

    return await this.httpService
      .get(url, {
        requestConfig: {
          cancellable: true,
          needCancelAtChangeRoute: true,
          forceRequest: true,
          baseUrl: this.getBaseUrl(),
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(error, url)
      })
  }

  private getBaseUrl() {
    return this.apiBaseUrl.replace('ru/api', 'ru/')
  }
}
